var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
        'background-image': _vm.qrCodeUrl ? ("url('" + _vm.qrCodeUrl + "')"): '',
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'width': '300px',
        'height': '300px'
    })}),_c('p',[_vm._v("Please print and display the QR code at the registration counter for the patient's quick check-in to your clinic.")]),_c('a',{staticClass:"btn btn-primary btn-primary-insv",attrs:{"href":_vm.qrCodeDownloadUrl,"target":"_blank"}},[_vm._v("Download QR Code")])])}
var staticRenderFns = []

export { render, staticRenderFns }